import { isSupabaseConfigured, supabase } from "../lib/supabase";
import { fulfillInventorySale } from "./inventory";
import almouneLogo from "../images/almoune-logo-1613775290.jpg";
import { printHtml } from "./print";

const STORAGE_KEY = "almoune_admin_orders";
const RECEIPT_STORE_INFO = {
  name: "Almoune",
  phone: "09 81 39 14 33",
  email: "contact@almoune.fr",
  address: "2 Pl. du Rouillon, 91000 Evry-Courcouronnes",
  vat: "TVA intracommunautaire: FR33890901648",
  siren: "SIREN: 890901648",
};

const computeReceiptTaxBreakdown = (items, taxRates) => {
  const breakdown = {};
  let totalHT = 0;
  for (const item of items) {
    const rate = taxRates.find((t) => t.id === item.tax_rate_id);
    const rateVal = rate ? rate.rate : 0;
    const ht = Number(item.unitPrice || 0) * Number(item.quantity || 0);
    totalHT += ht;
    const tvaKey = `${rateVal}%`;
    breakdown[tvaKey] = (breakdown[tvaKey] || 0) + Number((ht * rateVal / 100).toFixed(2));
  }
  const totalTVA = Object.values(breakdown).reduce((s, v) => s + v, 0);
  return { totalHT: Number(totalHT.toFixed(2)), breakdown, totalTVA: Number(totalTVA.toFixed(2)) };
};

export const orderStatusOptions = [
  "En attente",
  "Payee",
  "Preparation",
  "Livree",
  "Annulee",
];

export const paymentStatusOptions = [
  "En attente",
  "Payee",
  "Echouee",
  "Remboursee",
];

export const dispatchStatusOptions = [
  "Non preparee",
  "Prete",
  "En livraison",
  "Livree",
];

export const orderModeOptions = [
  { value: 'in_store', label: 'En magasin' },
  { value: 'takeaway', label: 'A emporter' },
  { value: 'delivery', label: 'A livrer' },
];

export const getOrderModeLabel = (mode) => orderModeOptions.find(o => o.value === mode)?.label || 'En magasin';

export const refundModeOptions = [
  { value: "none", label: "Sans remboursement" },
  { value: "refund", label: "Remboursement" },
  { value: "avoir", label: "Avoir client" },
];

export const orderLifecycleSteps = [
  {
    key: "pending",
    label: "En attente",
    description: "Commande recue, en attente de validation.",
  },
  {
    key: "paid",
    label: "Payee",
    description: "Commande validee et paiement confirme ou accepte.",
  },
  {
    key: "preparing",
    label: "Preparation",
    description: "Commande en preparation par l'equipe.",
  },
  {
    key: "ready",
    label: "Prete",
    description: "Commande preparee, prete a partir ou etre chargee.",
  },
  {
    key: "out_for_delivery",
    label: "En livraison",
    description: "Commande en cours d'acheminement.",
  },
  {
    key: "delivered",
    label: "Livree",
    description: "Commande remise au client.",
  },
];

export const defaultOrders = [
  {
    id: "order-2041",
    orderNumber: "AL-2041",
    client: "Nadine Khoury",
    phone: "09 81 39 14 33",
    email: "nadine@example.com",
    date: "2026-04-03",
    items: [
      {
        name: "Cafe Najjar Nature 220g",
        quantity: 2,
        unitPrice: 4.99,
        lineTotal: 9.98,
        unitType: "piece",
      },
      {
        name: "Pain Libanais - 5 pieces",
        quantity: 1,
        unitPrice: 3.2,
        lineTotal: 3.2,
        unitType: "piece",
      },
      {
        name: "Labneh Kolios 500g",
        quantity: 3,
        unitPrice: 6.4,
        lineTotal: 19.2,
        unitType: "piece",
      },
    ],
    status: "Preparation",
    paymentStatus: "Payee",
    dispatchStatus: "Prete",
    deliveryType: "Livraison fraiche",
    subtotal: 32.38,
    deliveryFee: 0,
    amount: 32.38,
    paymentMethod: "Carte bancaire",
    note: "Livraison matin si possible.",
  },
  {
    id: "order-2039",
    orderNumber: "AL-2039",
    client: "Karim Hanna",
    phone: "",
    email: "",
    date: "2026-04-03",
    items: [
      {
        name: "Zaatar Premium Naturel 500g",
        quantity: 1,
        unitPrice: 10.95,
        lineTotal: 10.95,
        unitType: "piece",
      },
      {
        name: "Cafe Najjar Nature 220g",
        quantity: 2,
        unitPrice: 4.95,
        lineTotal: 9.9,
        unitType: "piece",
      },
    ],
    status: "Payee",
    paymentStatus: "Payee",
    dispatchStatus: "En livraison",
    deliveryType: "Livraison standard",
    subtotal: 20.85,
    deliveryFee: 4,
    amount: 24.85,
    paymentMethod: "PayPal",
    note: "",
  },
  {
    id: "order-2035",
    orderNumber: "AL-2035",
    client: "Maya Tabet",
    phone: "",
    email: "",
    date: "2026-04-02",
    items: [
      {
        name: "Hallab 1881 - Le Baklava Frais du Liban",
        quantity: 2,
        unitPrice: 18.5,
        lineTotal: 37,
        unitType: "piece",
      },
      {
        name: "Pain Libanais - 5 pieces",
        quantity: 2,
        unitPrice: 3.2,
        lineTotal: 6.4,
        unitType: "piece",
      },
      {
        name: "Labneh Kolios 500g",
        quantity: 1,
        unitPrice: 6.7,
        lineTotal: 6.7,
        unitType: "piece",
      },
    ],
    status: "Livree",
    paymentStatus: "Payee",
    dispatchStatus: "Livree",
    deliveryType: "Livraison fraiche",
    subtotal: 50.1,
    deliveryFee: 42,
    amount: 92.1,
    paymentMethod: "Carte bancaire",
    note: "Commande VIP.",
  },
];

const orderStatusToDb = {
  "En attente": "pending",
  Payee: "paid",
  Preparation: "preparing",
  Livree: "delivered",
  Annulee: "cancelled",
};

const orderStatusFromDb = {
  pending: "En attente",
  paid: "Payee",
  preparing: "Preparation",
  delivered: "Livree",
  cancelled: "Annulee",
};

const paymentStatusToDb = {
  "En attente": "pending",
  Payee: "paid",
  Echouee: "failed",
  Remboursee: "refunded",
};

const paymentStatusFromDb = {
  pending: "En attente",
  paid: "Payee",
  failed: "Echouee",
  refunded: "Remboursee",
};

const dispatchStatusToDb = {
  "Non preparee": "not_dispatched",
  Prete: "ready",
  "En livraison": "out_for_delivery",
  Livree: "delivered",
};

const dispatchStatusFromDb = {
  not_dispatched: "Non preparee",
  ready: "Prete",
  out_for_delivery: "En livraison",
  delivered: "Livree",
};

const normalizeOrderItem = (item) => ({
  id: item.id || `${item.name || "item"}-${item.quantity || 1}`,
  productId: item.productId || item.product_id || "",
  variantId: item.variantId || item.variant_id || null,
  name: item.name || item.product_name || "Produit",
  variantName: item.variantName || item.variant_name || "",
  quantity: Number(item.quantity || 0),
  soldWeightKg:
    item.soldWeightKg === undefined || item.soldWeightKg === null
      ? item.sold_weight_kg === undefined || item.sold_weight_kg === null
        ? null
        : Number(item.sold_weight_kg)
      : Number(item.soldWeightKg),
  unitPrice: Number(item.unitPrice ?? item.unit_price ?? 0),
  lineTotal: Number(
    item.lineTotal ??
      item.line_total ??
      Number(item.unitPrice ?? item.unit_price ?? 0) * Number(item.quantity || 0)
  ),
  unitType: item.unitType || item.unit_type || "piece",
  isReturn: item.isReturn || false,
  restockOnComplete: item.restockOnComplete || false,
  returnRef: item.returnRef || null,
  returnReason: item.returnReason || "",
});

const buildOrderNumber = (id = "") => {
  if (!id) {
    return `AL-${Date.now().toString().slice(-6)}`;
  }

  if (id.startsWith("#")) {
    return id.slice(1);
  }

  if (id.startsWith("AL-")) {
    return id;
  }

  const numericPart = id.replace(/[^0-9]/g, "").slice(-6);
  return numericPart ? `AL-${numericPart}` : id;
};

const normalizeOrder = (order) => {
  const items = Array.isArray(order.items)
    ? order.items.map(normalizeOrderItem)
    : [];
  const subtotal =
    order.subtotal !== undefined
      ? Number(order.subtotal || 0)
      : items.reduce((sum, item) => sum + Number(item.lineTotal || 0), 0);
  const deliveryFee = Number(order.deliveryFee || 0);
  const amount =
    order.amount !== undefined
      ? Number(order.amount || 0)
      : subtotal + deliveryFee;

  return {
    id: order.id || `order-${Date.now()}`,
    orderNumber: order.orderNumber || buildOrderNumber(order.id),
    client: order.client || "",
    phone: order.phone || "",
    email: order.email || "",
    date:
      order.date ||
      (order.createdAt ? String(order.createdAt).slice(0, 10) : new Date().toISOString().slice(0, 10)),
    items,
    itemCount: items.reduce((sum, item) => sum + Number(item.quantity || 0), 0),
    status: order.status || "En attente",
    paymentStatus: order.paymentStatus || "En attente",
    dispatchStatus: order.dispatchStatus || "Non preparee",
    deliveryType: order.deliveryType || "Livraison standard",
    subtotal,
    deliveryFee,
    amount,
    paymentMethod: order.paymentMethod || "",
    invoiceNumber: order.invoiceNumber || order.invoice_number || "",
    invoiceGeneratedAt: order.invoiceGeneratedAt || order.invoice_generated_at || "",
    cancellationReason: order.cancellationReason || order.cancel_reason || "",
    cancelledAt: order.cancelledAt || order.cancelled_at || "",
    refundMode: order.refundMode || order.refund_mode || "none",
    refundAmount: Number(order.refundAmount ?? order.refund_amount ?? 0),
    refundIssuedAt: order.refundIssuedAt || order.refund_issued_at || "",
    creditNoteNumber: order.creditNoteNumber || order.credit_note_number || "",
    creditNoteIssuedAt: order.creditNoteIssuedAt || order.credit_note_issued_at || "",
    stockReturned: Boolean(order.stockReturned ?? order.stock_returned ?? false),
    assignedDriverId: order.assignedDriverId || order.assigned_driver_id || "",
    assignedDriverName: order.assignedDriverName || order.assigned_driver_name || "",
    note: order.note || "",
    amount_ht: Number(order.amount_ht ?? order.amountHt ?? subtotal),
    orderMode: order.orderMode || order.order_mode || 'in_store',
    savMessages: order.savMessages || order.sav_messages || [],
    tax_breakdown: order.tax_breakdown || order.taxBreakdown || {},
    isReturn: Boolean(order.isReturn),
    refundedFrom: order.refundedFrom || null,
  };
};

const mapLegacyRowToOrder = (row) =>
  normalizeOrder({
    id: row.id,
    orderNumber: row.id?.startsWith("#") ? row.id.slice(1) : buildOrderNumber(row.id),
    client: row.client,
    date: row.date,
    items: row.items,
    status:
      row.status === "Expediee"
        ? "Preparation"
        : row.status || "En attente",
    paymentStatus: row.payment_status || row.paymentStatus || "En attente",
    dispatchStatus: row.status === "Expediee" ? "En livraison" : undefined,
    deliveryType: row.delivery_type || row.deliveryType,
    amount: row.amount,
    note: row.note,
  });

const mapNormalizedRowToOrder = (row) =>
  normalizeOrder({
    id: row.id,
    orderNumber: row.order_number,
    client: row.customer_name,
    phone: row.customer_phone,
    email: row.customer_email,
    createdAt: row.created_at,
    items: row.order_items || [],
    status: orderStatusFromDb[row.status] || "En attente",
    paymentStatus: paymentStatusFromDb[row.payment_status] || "En attente",
    dispatchStatus:
      dispatchStatusFromDb[row.dispatch_status] || "Non preparee",
    deliveryType: row.delivery_label || "Livraison standard",
    subtotal: row.subtotal,
    deliveryFee: row.delivery_fee,
    amount: row.total_amount,
    invoiceNumber: row.invoice_number,
    invoiceGeneratedAt: row.invoice_generated_at,
    cancellationReason: row.cancel_reason,
    cancelledAt: row.cancelled_at,
    refundMode: row.refund_mode,
    refundAmount: row.refund_amount,
    refundIssuedAt: row.refund_issued_at,
    creditNoteNumber: row.credit_note_number,
    creditNoteIssuedAt: row.credit_note_issued_at,
    stockReturned: row.stock_returned,
    assignedDriverId: row.assigned_driver_id,
    assignedDriverName: row.assigned_driver_name,
    note: row.note,
  });

const readOrderCache = () => {
  if (typeof window === "undefined") {
    return defaultOrders.map(normalizeOrder);
  }

  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    const normalizedDefaults = defaultOrders.map(normalizeOrder);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizedDefaults));
    return normalizedDefaults;
  }

  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length === 0) {
      return defaultOrders.map(normalizeOrder);
    }
    return parsed.map(normalizeOrder);
  } catch (error) {
    return defaultOrders.map(normalizeOrder);
  }
};

const writeOrderCache = (orders) => {
  const normalized = orders.map(normalizeOrder);

  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  }

  return normalized;
};

const tryLoadNormalizedOrders = async () => {
  let { data, error } = await supabase
    .from("orders")
    .select(
      `
      id,
      order_number,
      customer_name,
      customer_phone,
      customer_email,
      status,
      payment_status,
      dispatch_status,
      subtotal,
      delivery_fee,
      total_amount,
      delivery_label,
      invoice_number,
      invoice_generated_at,
      cancel_reason,
      cancelled_at,
      refund_mode,
      refund_amount,
      refund_issued_at,
      credit_note_number,
      credit_note_issued_at,
      stock_returned,
      note,
      created_at,
      order_items (
        id,
        product_id,
        variant_id,
        product_name,
        variant_name,
        quantity,
        sold_weight_kg,
        unit_price,
        line_total,
        unit_type
      )
    `
    )
    .order("created_at", { ascending: false });

  if (error) {
    const fallback = await supabase
      .from("orders")
      .select(
        `
        id,
        order_number,
        customer_name,
        customer_phone,
        customer_email,
        status,
        payment_status,
        dispatch_status,
        subtotal,
        delivery_fee,
        total_amount,
        delivery_label,
        invoice_number,
        invoice_generated_at,
        note,
        created_at,
        order_items (
          id,
          product_id,
          variant_id,
          product_name,
          variant_name,
          quantity,
          sold_weight_kg,
          unit_price,
          line_total,
          unit_type
        )
      `
      )
      .order("created_at", { ascending: false });

    if (fallback.error) {
      throw fallback.error;
    }

    data = fallback.data;
  }

  return data.map(mapNormalizedRowToOrder);
};

const tryLoadLegacyOrders = async () => {
  const { data, error } = await supabase
    .from("orders")
    .select(
      "id, client, date, items, status, payment_status, delivery_type, amount, note"
    )
    .order("date", { ascending: false });

  if (error) {
    throw error;
  }

  return data.map(mapLegacyRowToOrder);
};

export const getOrders = () => readOrderCache();

export const loadOrders = async () => {
  const cached = readOrderCache();

  if (!isSupabaseConfigured || !supabase) {
    return cached;
  }

  try {
    const normalizedOrders = await tryLoadNormalizedOrders();
    if (!normalizedOrders.length) {
      return cached;
    }
    return writeOrderCache(normalizedOrders);
  } catch (normalizedError) {
    try {
      const legacyOrders = await tryLoadLegacyOrders();
      if (!legacyOrders.length) {
        return cached;
      }
      return writeOrderCache(legacyOrders);
    } catch (legacyError) {
      return cached;
    }
  }
};

const buildNormalizedOrderPayload = (order, includeWorkflowMeta = true) => ({
    id: order.id,
    order_number: order.orderNumber,
    customer_name: order.client,
    customer_phone: order.phone || "",
    customer_email: order.email || "",
    status: orderStatusToDb[order.status] || "pending",
    payment_status: paymentStatusToDb[order.paymentStatus] || "pending",
    dispatch_status:
      dispatchStatusToDb[order.dispatchStatus] || "not_dispatched",
    subtotal: Number(order.subtotal || 0),
    delivery_fee: Number(order.deliveryFee || 0),
    total_amount: Number(order.amount || 0),
    delivery_label: order.deliveryType || "",
    invoice_number: order.invoiceNumber || null,
    invoice_generated_at: order.invoiceGeneratedAt || null,
    ...(includeWorkflowMeta
      ? {
          cancel_reason: order.cancellationReason || "",
          cancelled_at: order.cancelledAt || null,
          refund_mode: order.refundMode || "none",
          refund_amount: Number(order.refundAmount || 0),
          refund_issued_at: order.refundIssuedAt || null,
          credit_note_number: order.creditNoteNumber || null,
          credit_note_issued_at: order.creditNoteIssuedAt || null,
          stock_returned: Boolean(order.stockReturned),
        }
      : {}),
    note: order.note || "",
    assigned_driver_id: order.assignedDriverId || "",
    assigned_driver_name: order.assignedDriverName || "",
  });

const saveOrdersToNormalizedSchema = async (orders) => {
  let payload = orders.map((order) => buildNormalizedOrderPayload(order, true));

  let { error } = await supabase.from("orders").upsert(payload, {
    onConflict: "id",
  });

  if (error) {
    payload = orders.map((order) => buildNormalizedOrderPayload(order, false));
    const fallback = await supabase.from("orders").upsert(payload, {
      onConflict: "id",
    });
    error = fallback.error;
  }

  if (error) {
    throw error;
  }

  const orderIds = orders.map((order) => order.id).filter(Boolean);

  if (orderIds.length) {
    const { error: deleteItemsError } = await supabase
      .from("order_items")
      .delete()
      .in("order_id", orderIds);

    if (deleteItemsError) {
      throw deleteItemsError;
    }
  }

  const itemsPayload = orders.flatMap((order) =>
    (order.items || []).map((item) => ({
      id: item.id?.startsWith?.("item-") ? item.id : undefined,
      order_id: order.id,
      product_id: item.productId || `manual-${order.id}-${item.name}`,
      variant_id: item.variantId || null,
      product_name: item.name,
      variant_name: item.variantName || "",
      quantity: Number(item.quantity || 0),
      unit_type: item.unitType || "piece",
      sold_weight_kg:
        item.soldWeightKg === null || item.soldWeightKg === undefined
          ? null
          : Number(item.soldWeightKg),
      unit_price: Number(item.unitPrice || 0),
      line_total: Number(item.lineTotal || 0),
    }))
  );

  if (itemsPayload.length) {
    const { error: itemsInsertError } = await supabase
      .from("order_items")
      .insert(itemsPayload);

    if (itemsInsertError) {
      throw itemsInsertError;
    }
  }
};

const saveOrdersToLegacySchema = async (orders) => {
  const payload = orders.map((order) => ({
    id: order.id.startsWith("#") ? order.id : `#${order.orderNumber}`,
    client: order.client,
    date: order.date,
    items: order.items.map((item) => ({
      name: item.name,
      quantity: item.quantity,
    })),
    status:
      order.dispatchStatus === "En livraison" ? "Expediee" : order.status,
    payment_status: order.paymentStatus,
    delivery_type: order.deliveryType,
    amount: Number(order.amount || 0),
    note: order.note,
  }));

  const { error } = await supabase.from("orders").upsert(payload, {
    onConflict: "id",
  });

  if (error) {
    throw error;
  }
};

export const saveOrders = async (orders) => {
  const normalized = writeOrderCache(orders);

  if (!isSupabaseConfigured || !supabase) {
    return normalized;
  }

  try {
    await saveOrdersToNormalizedSchema(normalized);
    return normalized;
  } catch (normalizedError) {
    try {
      await saveOrdersToLegacySchema(normalized);
      return normalized;
    } catch (legacyError) {
      return normalized;
    }
  }
};

export const formatOrderAmount = (value) =>
  `${Number(value || 0).toFixed(2)} EUR`;

export const getOrderLifecycleKey = (order) => {
  if (order?.status === "Annulee") {
    return "cancelled";
  }
  if (order?.dispatchStatus === "Livree" || order?.status === "Livree") {
    return "delivered";
  }
  if (order?.dispatchStatus === "En livraison") {
    return "out_for_delivery";
  }
  if (order?.dispatchStatus === "Prete") {
    return "ready";
  }
  if (order?.status === "Preparation") {
    return "preparing";
  }
  if (order?.paymentStatus === "Payee" || order?.status === "Payee") {
    return "paid";
  }
  return "pending";
};

export const getOrderLifecycleLabel = (order) => {
  const key = getOrderLifecycleKey(order);
  return orderLifecycleSteps.find((step) => step.key === key)?.label || "En attente";
};

export const getOrderLifecycleBadgeClass = (order) => {
  const key = getOrderLifecycleKey(order);
  return (
    {
      pending: "bg-warning text-dark",
      paid: "bg-primary",
      preparing: "bg-info text-dark",
      ready: "bg-secondary",
      out_for_delivery: "bg-dark",
      delivered: "bg-success",
      cancelled: "bg-light text-dark border",
    }[key] || "bg-light text-dark"
  );
};

export const getRefundModeLabel = (refundMode) =>
  refundModeOptions.find((option) => option.value === refundMode)?.label || "Sans remboursement";

export const getOrderSettlementLabel = (order) => {
  if (order?.status === "Annulee" && order?.refundMode === "avoir") {
    return order.creditNoteNumber
      ? `Avoir emis (${order.creditNoteNumber})`
      : "Avoir a emettre";
  }

  if (order?.status === "Annulee" && order?.refundMode === "refund") {
    return order.refundIssuedAt ? "Rembourse" : "Remboursement a traiter";
  }

  if (order?.status === "Annulee") {
    return "Annulation sans remboursement";
  }

  return order?.paymentStatus || "En attente";
};

const buildCreditNoteNumber = (order) => {
  const baseOrderNumber = order?.orderNumber || buildOrderNumber(order?.id);
  const normalizedOrderNumber = String(baseOrderNumber).replace(/^AL-/, "");
  return `AV-${normalizedOrderNumber}`;
};

const buildInvoiceNumber = (order) => {
  const baseOrderNumber = order?.orderNumber || buildOrderNumber(order?.id);
  const normalizedOrderNumber = String(baseOrderNumber).replace(/^AL-/, "");
  return `FAC-${normalizedOrderNumber}`;
};

export const applyOrderWorkflowChange = (order, field, value) => {
  const nextOrder = normalizeOrder({ ...order, [field]: value });

  if (field === "paymentStatus") {
    if (value === "Payee" && nextOrder.status === "En attente") {
      nextOrder.status = "Payee";
    }
    if (value === "Remboursee" && nextOrder.status === "Livree") {
      nextOrder.dispatchStatus = "Livree";
    }
  }

  if (field === "status") {
    if (value === "Annulee") {
      nextOrder.dispatchStatus = "Non preparee";
    }
    if (value === "Payee" && nextOrder.paymentStatus === "En attente") {
      nextOrder.paymentStatus = "Payee";
    }
    if (value === "Preparation" && nextOrder.paymentStatus === "En attente") {
      nextOrder.paymentStatus = "Payee";
    }
    if (value === "Livree") {
      nextOrder.dispatchStatus = "Livree";
      if (nextOrder.paymentStatus === "En attente") {
        nextOrder.paymentStatus = "Payee";
      }
    }
  }

  if (field === "dispatchStatus") {
    if (value === "Prete" && !["Preparation", "Livree", "Annulee"].includes(nextOrder.status)) {
      nextOrder.status = "Preparation";
    }
    if (value === "En livraison") {
      nextOrder.status = "Payee";
      if (nextOrder.paymentStatus === "En attente") {
        nextOrder.paymentStatus = "Payee";
      }
    }
    if (value === "Livree") {
      nextOrder.status = "Livree";
      if (nextOrder.paymentStatus === "En attente") {
        nextOrder.paymentStatus = "Payee";
      }
    }
  }

  return normalizeOrder(nextOrder);
};

export const applyOrderCancellation = (
  order,
  {
    reason = "",
    refundMode = "none",
    refundAmount = 0,
    stockReturned = false,
  } = {}
) => {
  const cancelledAt = new Date().toISOString();
  const normalizedRefundAmount = Number(refundAmount || order.amount || 0);

  return normalizeOrder({
    ...order,
    status: "Annulee",
    dispatchStatus: "Non preparee",
    paymentStatus: refundMode === "none" ? order.paymentStatus : "Remboursee",
    cancellationReason: reason,
    cancelledAt,
    refundMode,
    refundAmount: normalizedRefundAmount,
    refundIssuedAt: refundMode === "refund" ? cancelledAt : "",
    creditNoteNumber: refundMode === "avoir" ? buildCreditNoteNumber(order) : "",
    creditNoteIssuedAt: refundMode === "avoir" ? cancelledAt : "",
    stockReturned,
  });
};

export const ensureOrderInvoice = (order) =>
  normalizeOrder({
    ...order,
    invoiceNumber: order?.invoiceNumber || buildInvoiceNumber(order),
    invoiceGeneratedAt: order?.invoiceGeneratedAt || new Date().toISOString(),
  });

export const advanceOrderWorkflow = (order) => {
  const lifecycleKey = getOrderLifecycleKey(order);

  if (lifecycleKey === "cancelled" || lifecycleKey === "delivered") {
    return normalizeOrder(order);
  }

  if (lifecycleKey === "pending") {
    return applyOrderWorkflowChange(order, "paymentStatus", "Payee");
  }

  if (lifecycleKey === "paid") {
    return applyOrderWorkflowChange(order, "status", "Preparation");
  }

  if (lifecycleKey === "preparing") {
    return applyOrderWorkflowChange(order, "dispatchStatus", "Prete");
  }

  if (lifecycleKey === "ready") {
    return applyOrderWorkflowChange(order, "dispatchStatus", "En livraison");
  }

  if (lifecycleKey === "out_for_delivery") {
    return applyOrderWorkflowChange(order, "dispatchStatus", "Livree");
  }

  return normalizeOrder(order);
};

export const getNextOrderWorkflowAction = (order) => {
  const lifecycleKey = getOrderLifecycleKey(order);

  return (
    {
      pending: "Valider la commande",
      paid: "Lancer la preparation",
      preparing: "Marquer prete",
      ready: "Envoyer en livraison",
      out_for_delivery: "Marquer livree",
    }[lifecycleKey] || ""
  );
};

export const formatOrderDate = (value) => {
  if (!value) {
    return "";
  }

  const normalized =
    value.includes("T") || value.includes(" ")
      ? value.slice(0, 10)
      : value;
  const [year, month, day] = normalized.split("-");

  if (!year || !month || !day) {
    return value;
  }

  return `${day}/${month}/${year}`;
};

const escapeHtml = (value) =>
  String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");

export const buildAvoirPrintHtml = (order) => {
  const printedAt = new Date().toLocaleString("fr-FR");
  const creditNoteNumber = order?.creditNoteNumber || buildCreditNoteNumber(order);
  const rows = (order?.items || [])
    .map((item) => {
      const quantityLabel =
        item?.unitType === "kg" || item?.soldWeightKg !== null
          ? `${Number(item?.soldWeightKg ?? item?.quantity ?? 0).toFixed(3)} kg`
          : `${Number(item?.quantity || 0)}`;

      return `
        <tr>
          <td>${escapeHtml(item.name || "Produit")}</td>
          <td>${escapeHtml(item.variantName || "")}</td>
          <td style="text-align:right;">${escapeHtml(quantityLabel)}</td>
          <td style="text-align:right;">${escapeHtml(formatOrderAmount(item.unitPrice || 0))}</td>
          <td style="text-align:right;">${escapeHtml(formatOrderAmount(item.lineTotal || 0))}</td>
        </tr>
      `;
    })
    .join("");

  return `<!doctype html>
<html lang="fr">
  <head>
    <meta charset="utf-8" />
    <title>Avoir ${escapeHtml(creditNoteNumber)}</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        color: #1f2937;
        margin: 0;
        padding: 32px;
        background: #ffffff;
      }
      .document {
        max-width: 900px;
        margin: 0 auto;
      }
      .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 24px;
        margin-bottom: 32px;
      }
      .title {
        font-size: 30px;
        font-weight: 700;
        margin: 0 0 8px;
      }
      .muted {
        color: #6b7280;
      }
      .box {
        border: 1px solid #d1d5db;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 20px;
      }
      .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 8px;
      }
      th, td {
        border-bottom: 1px solid #e5e7eb;
        padding: 10px 8px;
        font-size: 14px;
        vertical-align: top;
      }
      th {
        text-align: left;
        background: #f9fafb;
      }
      .totals {
        margin-top: 20px;
        margin-left: auto;
        width: 320px;
      }
      .totals-row {
        display: flex;
        justify-content: space-between;
        padding: 8px 0;
        border-bottom: 1px solid #e5e7eb;
      }
      .totals-row.total {
        font-weight: 700;
        font-size: 16px;
      }
      .footer {
        margin-top: 28px;
        font-size: 13px;
        color: #6b7280;
      }
      @media print {
        body {
          padding: 0;
        }
        .document {
          max-width: none;
        }
      }
    </style>
  </head>
  <body>
    <div class="document">
      <div class="header">
        <div>
          <p class="title">Avoir</p>
          <div class="muted">Document d'avoir client</div>
        </div>
        <div>
          <div><strong>Avoir :</strong> ${escapeHtml(creditNoteNumber)}</div>
          <div><strong>Commande :</strong> ${escapeHtml(order?.orderNumber || order?.id || "")}</div>
          <div><strong>Date :</strong> ${escapeHtml(formatOrderDate(order?.creditNoteIssuedAt || order?.cancelledAt || order?.date || ""))}</div>
          <div><strong>Imprime le :</strong> ${escapeHtml(printedAt)}</div>
        </div>
      </div>

      <div class="grid">
        <div class="box">
          <div><strong>Client</strong></div>
          <div>${escapeHtml(order?.client || "Client Almoune")}</div>
          <div>${escapeHtml(order?.phone || "")}</div>
          <div>${escapeHtml(order?.email || "")}</div>
        </div>
        <div class="box">
          <div><strong>Motif</strong></div>
          <div>${escapeHtml(order?.cancellationReason || "Annulation de commande")}</div>
          <div class="muted" style="margin-top:8px;">
            Mode: ${escapeHtml(getRefundModeLabel(order?.refundMode || "avoir"))}
          </div>
        </div>
      </div>

      <div class="box">
        <div><strong>Lignes concernees</strong></div>
        <table>
          <thead>
            <tr>
              <th>Produit</th>
              <th>Variante</th>
              <th style="text-align:right;">Quantite</th>
              <th style="text-align:right;">Prix unit.</th>
              <th style="text-align:right;">Total</th>
            </tr>
          </thead>
          <tbody>
            ${rows}
          </tbody>
        </table>
        <div class="totals">
          <div class="totals-row">
            <span>Montant commande</span>
            <span>${escapeHtml(formatOrderAmount(order?.amount || 0))}</span>
          </div>
          <div class="totals-row total">
            <span>Montant avoir</span>
            <span>${escapeHtml(formatOrderAmount(order?.refundAmount || order?.amount || 0))}</span>
          </div>
        </div>
      </div>

      <div class="footer">
        Avoir emis pour annulation ou ajustement commercial. Ce document peut etre imprime ou enregistre en PDF depuis le navigateur.
      </div>
    </div>
  </body>
</html>`;
};

export const buildInvoicePrintHtml = (order) => {
  const invoiceOrder = ensureOrderInvoice(order);
  const printedAt = new Date().toLocaleString("fr-FR");
  const hasReturns = (invoiceOrder?.items || []).some((item) => item.isReturn);
  const rows = (invoiceOrder?.items || [])
    .map((item) => {
      const quantityLabel =
        item?.unitType === "kg" || item?.soldWeightKg !== null
          ? `${Number(item?.soldWeightKg ?? item?.quantity ?? 0).toFixed(3)} kg`
          : `${Number(item?.quantity || 0)}`;

      const returnBadge = item.isReturn
        ? `<span style="color:#dc2626;font-weight:700;font-size:11px;">RETOUR</span> `
        : "";
      const amountStyle = Number(item.lineTotal) < 0 ? 'style="color:#dc2626;"' : "";

      return `
        <tr>
          <td>${returnBadge}${escapeHtml(item.name || "Produit")}</td>
          <td>${escapeHtml(item.variantName || "")}</td>
          <td style="text-align:right;">${escapeHtml(quantityLabel)}</td>
          <td style="text-align:right;">${escapeHtml(formatOrderAmount(item.unitPrice || 0))}</td>
          <td style="text-align:right;" ${amountStyle}>${escapeHtml(formatOrderAmount(item.lineTotal || 0))}</td>
        </tr>
      `;
    })
    .join("");

  return `<!doctype html>
<html lang="fr">
  <head>
    <meta charset="utf-8" />
    <title>Facture ${escapeHtml(invoiceOrder.invoiceNumber)}</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        color: #1f2937;
        margin: 0;
        padding: 32px;
        background: #ffffff;
      }
      .document {
        max-width: 900px;
        margin: 0 auto;
      }
      .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 24px;
        margin-bottom: 32px;
      }
      .title {
        font-size: 30px;
        font-weight: 700;
        margin: 0 0 8px;
      }
      .muted { color: #6b7280; }
      .box {
        border: 1px solid #d1d5db;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 20px;
      }
      .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 8px;
      }
      th, td {
        border-bottom: 1px solid #e5e7eb;
        padding: 10px 8px;
        font-size: 14px;
        vertical-align: top;
      }
      th {
        text-align: left;
        background: #f9fafb;
      }
      .totals {
        margin-top: 20px;
        margin-left: auto;
        width: 320px;
      }
      .totals-row {
        display: flex;
        justify-content: space-between;
        padding: 8px 0;
        border-bottom: 1px solid #e5e7eb;
      }
      .totals-row.total {
        font-weight: 700;
        font-size: 16px;
      }
      .footer {
        margin-top: 28px;
        font-size: 13px;
        color: #6b7280;
      }
      @media print {
        body { padding: 0; }
        .document { max-width: none; }
      }
    </style>
  </head>
  <body>
    <div class="document">
      <div class="header">
        <div>
          <p class="title">${invoiceOrder.isReturn ? "Facture d'avoir" : "Facture"}</p>
          <div class="muted">Document de facturation client</div>
        </div>
        <div>
          <div><strong>Facture :</strong> ${escapeHtml(invoiceOrder.invoiceNumber)}</div>
          <div><strong>Commande :</strong> ${escapeHtml(invoiceOrder.orderNumber || invoiceOrder.id || "")}</div>
          <div><strong>Date facture :</strong> ${escapeHtml(formatOrderDate(invoiceOrder.invoiceGeneratedAt || invoiceOrder.date || ""))}</div>
          <div><strong>Imprime le :</strong> ${escapeHtml(printedAt)}</div>
          ${invoiceOrder.refundedFrom ? `<div style="color:#dc2626;"><strong>Commande d'origine :</strong> ${escapeHtml(invoiceOrder.refundedFrom)}</div>` : ""}
        </div>
      </div>

      <div class="grid">
        <div class="box">
          <div><strong>Client</strong></div>
          <div>${escapeHtml(invoiceOrder.client || "Client Almoune")}</div>
          <div>${escapeHtml(invoiceOrder.phone || "")}</div>
          <div>${escapeHtml(invoiceOrder.email || "")}</div>
        </div>
        <div class="box">
          <div><strong>Commande</strong></div>
          <div>${escapeHtml(invoiceOrder.deliveryType || "Livraison standard")}</div>
          <div class="muted" style="margin-top:8px;">Paiement: ${escapeHtml(invoiceOrder.paymentMethod || invoiceOrder.paymentStatus || "Non renseigne")}</div>
          <div class="muted">Statut: ${escapeHtml(getOrderLifecycleLabel(invoiceOrder))}</div>
        </div>
      </div>

      <div class="box">
        <div><strong>Lignes facturees</strong></div>
        <table>
          <thead>
            <tr>
              <th>Produit</th>
              <th>Variante</th>
              <th style="text-align:right;">Quantite</th>
              <th style="text-align:right;">Prix unit.</th>
              <th style="text-align:right;">Total</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
        <div class="totals">
          <div class="totals-row">
            <span>Sous-total HT</span>
            <span>${escapeHtml(formatOrderAmount(invoiceOrder.amount_ht || invoiceOrder.subtotal || 0))}</span>
          </div>
          ${Object.entries(invoiceOrder?.tax_breakdown || {}).map(([rate, amount]) =>
            `<div class="totals-row"><span>TVA ${escapeHtml(rate)}</span><span>${escapeHtml(formatOrderAmount(amount))}</span></div>`
          ).join("")}
          <div class="totals-row">
            <span>Livraison</span>
            <span>${escapeHtml(formatOrderAmount(invoiceOrder.deliveryFee || 0))}</span>
          </div>
          <div class="totals-row total">
            <span>Total</span>
            <span>${escapeHtml(formatOrderAmount(invoiceOrder.amount || 0))}</span>
          </div>
        </div>
      </div>

      <div class="footer">
        Facture imprimee depuis Almoune. Ce document peut etre imprime ou enregistre en PDF depuis le navigateur.
      </div>
    </div>
  </body>
</html>`;
};

export const buildDeliveryNotePrintHtml = (order) => {
  const deliveryOrder = normalizeOrder(order || {});
  const printedAt = new Date().toLocaleString("fr-FR");
  const rows = (deliveryOrder.items || [])
    .map((item, index) => {
      const quantityLabel = isWeightedOrderItem(item)
        ? `${Number(item?.soldWeightKg ?? item?.quantity ?? 0).toFixed(3)} kg`
        : `${Number(item?.quantity || 0)}`;

      return `
        <tr>
          <td style="text-align:center;">${index + 1}</td>
          <td>${escapeHtml(item.name || "Produit")}</td>
          <td>${escapeHtml(item.variantName || "-")}</td>
          <td style="text-align:right;">${escapeHtml(quantityLabel)}</td>
          <td>${escapeHtml(item.unitType || "piece")}</td>
        </tr>
      `;
    })
    .join("");

  return `<!doctype html>
<html lang="fr">
  <head>
    <meta charset="utf-8" />
    <title>Bon de livraison ${escapeHtml(deliveryOrder.orderNumber || deliveryOrder.id || "")}</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        color: #1f2937;
        margin: 0;
        padding: 32px;
        background: #ffffff;
      }
      .document {
        max-width: 900px;
        margin: 0 auto;
      }
      .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 24px;
        margin-bottom: 32px;
      }
      .title {
        font-size: 30px;
        font-weight: 700;
        margin: 0 0 8px;
      }
      .muted { color: #6b7280; }
      .box {
        border: 1px solid #d1d5db;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 20px;
      }
      .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 8px;
      }
      th, td {
        border-bottom: 1px solid #e5e7eb;
        padding: 10px 8px;
        font-size: 14px;
        vertical-align: top;
      }
      th {
        text-align: left;
        background: #f9fafb;
      }
      .signature-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        margin-top: 20px;
      }
      .signature-box {
        border: 1px dashed #9ca3af;
        border-radius: 12px;
        min-height: 110px;
        padding: 14px;
      }
      .footer {
        margin-top: 28px;
        font-size: 13px;
        color: #6b7280;
      }
      @media print {
        body { padding: 0; }
        .document { max-width: none; }
      }
    </style>
  </head>
  <body>
    <div class="document">
      <div class="header">
        <div>
          <p class="title">Bon de livraison</p>
          <div class="muted">Document de preparation et remise de commande</div>
        </div>
        <div>
          <div><strong>Commande :</strong> ${escapeHtml(deliveryOrder.orderNumber || deliveryOrder.id || "")}</div>
          <div><strong>Date commande :</strong> ${escapeHtml(formatOrderDate(deliveryOrder.date || ""))}</div>
          <div><strong>Imprime le :</strong> ${escapeHtml(printedAt)}</div>
          <div><strong>Expedition :</strong> ${escapeHtml(deliveryOrder.dispatchStatus || "Non preparee")}</div>
        </div>
      </div>

      <div class="grid">
        <div class="box">
          <div><strong>Client</strong></div>
          <div>${escapeHtml(deliveryOrder.client || "Client Almoune")}</div>
          <div>${escapeHtml(deliveryOrder.phone || "")}</div>
          <div>${escapeHtml(deliveryOrder.email || "")}</div>
        </div>
        <div class="box">
          <div><strong>Livraison</strong></div>
          <div>${escapeHtml(deliveryOrder.deliveryType || "Livraison standard")}</div>
          <div class="muted" style="margin-top:8px;">Statut commande: ${escapeHtml(getOrderLifecycleLabel(deliveryOrder))}</div>
          <div class="muted">Paiement: ${escapeHtml(deliveryOrder.paymentMethod || deliveryOrder.paymentStatus || "Non renseigne")}</div>
          ${deliveryOrder.assignedDriverName ? `<div class="muted" style="margin-top:8px;"><strong>Livreur:</strong> ${escapeHtml(deliveryOrder.assignedDriverName)}</div>` : ""}
        </div>
      </div>

      <div class="box">
        <div><strong>Articles a remettre</strong></div>
        <table>
          <thead>
            <tr>
              <th style="width:60px; text-align:center;">#</th>
              <th>Produit</th>
              <th>Variante</th>
              <th style="text-align:right;">Quantite</th>
              <th>Unite</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      </div>

      <div class="box">
        <div><strong>Consignes</strong></div>
        <div>${escapeHtml(deliveryOrder.note || "Aucune consigne particuliere.")}</div>
      </div>

      <div class="signature-grid">
        <div class="signature-box">
          <strong>Preparation / expedition</strong>
          <div class="muted" style="margin-top:8px;">Nom, date et signature</div>
        </div>
        <div class="signature-box">
          <strong>Reception client</strong>
          <div class="muted" style="margin-top:8px;">Nom, date et signature</div>
        </div>
      </div>

      <div class="footer">
        Bon de livraison imprime depuis Almoune. Ce document peut etre imprime ou enregistre en PDF depuis le navigateur.
      </div>
    </div>
  </body>
</html>`;
};

export const buildCashierReceiptPrintHtml = (order) => {
  const receiptOrder = normalizeOrder(order || {});
  const printedAt = new Date().toLocaleString("fr-FR");
  const hasReturns = (receiptOrder.items || []).some((item) => item.isReturn);
  const rows = (receiptOrder.items || [])
    .map((item) => {
      const quantityLabel = isWeightedOrderItem(item)
        ? `${Number(item?.soldWeightKg ?? item?.quantity ?? 0).toFixed(3)} kg`
        : `${Number(item?.quantity || 0)}`;

      const returnBadge = item.isReturn
        ? `<span style="color:#dc2626;font-weight:700;font-size:11px;">RETOUR</span> `
        : "";
      const amountStyle = Number(item.lineTotal) < 0 ? 'style="color:#dc2626;"' : "";

      return `
        <tr>
          <td>
            <div>${returnBadge}${escapeHtml(item.name || "Produit")}</div>
            ${item.returnRef ? `<div style="color:#6b7280;font-size:11px;">Réf: ${escapeHtml(item.returnRef)}</div>` : ""}
            ${item.variantName ? `<div class="muted">${escapeHtml(item.variantName)}</div>` : ""}
          </td>
          <td style="text-align:right;">${escapeHtml(quantityLabel)}</td>
          <td style="text-align:right;" ${amountStyle}>${escapeHtml(formatOrderAmount(item.lineTotal || 0))}</td>
        </tr>
      `;
    })
    .join("");

  return `<!doctype html>
<html lang="fr">
  <head>
    <meta charset="utf-8" />
    <title>Ticket ${escapeHtml(receiptOrder.orderNumber || receiptOrder.id || "")}</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        color: #1b1b18;
        margin: 0;
        padding: 18px;
        background: #f7f2ea;
      }
      .ticket {
        width: 360px;
        margin: 0 auto;
        background: #fffdf9;
        border: 1px solid #e7dcc9;
        border-radius: 20px;
        box-shadow: 0 18px 40px rgba(79, 51, 24, 0.08);
        overflow: hidden;
      }
      .hero {
        padding: 18px 18px 14px;
        background: linear-gradient(180deg, #fff6e8 0%, #fffdf9 100%);
        border-bottom: 1px solid #efe2cf;
      }
      .center { text-align: center; }
      .logo {
        width: 148px;
        max-width: 100%;
        height: auto;
        display: block;
        margin: 0 auto 10px;
      }
      .title {
        font-size: 21px;
        font-weight: 700;
        margin: 0 0 4px;
        letter-spacing: 0.01em;
      }
      .muted {
        color: #766a5a;
        font-size: 12px;
      }
      .divider {
        border-top: 1px dashed #cdbda8;
        margin: 14px 18px;
      }
      table {
        width: 100%;
        border-collapse: collapse;
      }
      td, th {
        padding: 7px 0;
        vertical-align: top;
        font-size: 13px;
      }
      .content {
        padding: 0 18px 18px;
      }
      .meta-card {
        background: #fbf7f0;
        border: 1px solid #eee2d1;
        border-radius: 14px;
        padding: 12px 14px;
      }
      .meta-card + .meta-card {
        margin-top: 10px;
      }
      .totals-row {
        display: flex;
        justify-content: space-between;
        padding: 5px 0;
        font-size: 14px;
      }
      .totals-row.total {
        font-size: 18px;
        font-weight: 700;
        color: #8b3d12;
      }
      .footer-note {
        background: #faf4ea;
        border-top: 1px solid #eee0c8;
        padding: 12px 18px 16px;
      }
      .kicker {
        text-transform: uppercase;
        letter-spacing: 0.12em;
        font-size: 10px;
        color: #9a8569;
        margin-bottom: 8px;
      }
      @media print {
        body {
          padding: 0;
          background: #ffffff;
        }
        .ticket {
          width: auto;
          margin: 0;
          border: 0;
          border-radius: 0;
          box-shadow: none;
        }
      }
    </style>
  </head>
  <body>
    <div class="ticket">
      <div class="hero center">
        <img class="logo" src="${almouneLogo}" alt="Almoune" />
        <div class="kicker">${receiptOrder.isReturn ? "AVOIR" : "Ticket de caisse"}</div>
        <p class="title">${escapeHtml(RECEIPT_STORE_INFO.name)}</p>
        <div class="muted">${escapeHtml(RECEIPT_STORE_INFO.address)}</div>
        <div class="muted">${escapeHtml(RECEIPT_STORE_INFO.phone)} · ${escapeHtml(RECEIPT_STORE_INFO.email)}</div>
      </div>

      <div class="content">
        <div class="divider"></div>

        <div class="meta-card">
          <div><strong>Commande:</strong> ${escapeHtml(receiptOrder.orderNumber || receiptOrder.id || "")}</div>
          <div><strong>Date:</strong> ${escapeHtml(printedAt)}</div>
          <div><strong>Paiement:</strong> ${escapeHtml(receiptOrder.paymentMethod || "Especes")}</div>
          ${receiptOrder.refundedFrom ? `<div style="color:#dc2626;"><strong>Commande d'origine:</strong> ${escapeHtml(receiptOrder.refundedFrom)}</div>` : ""}
          ${receiptOrder.note && receiptOrder.note.includes("Carte cadeau") ? `
            <div style="margin-top: 8px; padding: 8px; background: #f0f7f0; border-radius: 8px;">
              <div style="font-weight: 600; font-size: 12px; margin-bottom: 4px;">Carte cadeau:</div>
              ${receiptOrder.note.split("|").filter((p) => p.includes("Carte cadeau")).map((p) => `<div style="font-size: 11px; color: #2d6a4f;">${escapeHtml(p.trim())}</div>`).join("")}
            </div>
          ` : ""}
          ${receiptOrder.note && receiptOrder.note.includes("Points fidelite") ? `
            <div style="margin-top: 8px; padding: 8px; background: #f0f7f0; border-radius: 8px;">
              <div style="font-weight: 600; font-size: 12px; margin-bottom: 4px;">Fidelite:</div>
              ${receiptOrder.note.split("|").filter((p) => p.includes("Points fidelite")).map((p) => `<div style="font-size: 11px; color: #2d6a4f;">${escapeHtml(p.trim())}</div>`).join("")}
            </div>
          ` : ""}
        </div>

        <div class="meta-card">
          <div><strong>Client:</strong> ${escapeHtml(receiptOrder.client || "Client comptoir")}</div>
          ${receiptOrder.phone ? `<div><strong>Tel:</strong> ${escapeHtml(receiptOrder.phone)}</div>` : ""}
        </div>

        <div class="divider"></div>

        <table>
          <thead>
            <tr>
              <th>Article</th>
              <th style="text-align:right;">Qt.</th>
              <th style="text-align:right;">Total</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>

        <div class="divider"></div>

        <div class="totals-row">
          <span>Sous-total HT</span>
          <span>${escapeHtml(formatOrderAmount(receiptOrder.amount_ht || receiptOrder.subtotal || 0))}</span>
        </div>
        ${Object.entries(receiptOrder.tax_breakdown || {}).map(([rate, amount]) =>
          `<div class="totals-row"><span>TVA ${escapeHtml(rate)}</span><span>${escapeHtml(formatOrderAmount(amount))}</span></div>`
        ).join("")}
        <div class="totals-row">
          <span>Livraison</span>
          <span>${escapeHtml(formatOrderAmount(receiptOrder.deliveryFee || 0))}</span>
        </div>
        <div class="totals-row total">
          <span>Total</span>
          <span>${escapeHtml(formatOrderAmount(receiptOrder.amount || 0))}</span>
        </div>

        ${receiptOrder.note ? `<div class="divider"></div><div class="muted">${escapeHtml(receiptOrder.note)}</div>` : ""}
      </div>

      <div class="footer-note center">
        <div class="muted">${escapeHtml(RECEIPT_STORE_INFO.vat)}</div>
        <div class="muted" style="margin-top:4px;">${escapeHtml(RECEIPT_STORE_INFO.siren)}</div>
        <div class="muted" style="margin-top:6px;">Merci et a bientot chez Almoune.</div>
      </div>
    </div>
  </body>
</html>`;
};

export const buildThermalCashierReceiptHtml = (order) => {
  const o = normalizeOrder(order || {});
  const printedAt = new Date().toLocaleString("fr-FR");
  const items = (o.items || []).map((item) => {
    const qty = isWeightedOrderItem(item)
      ? `${Number(item?.soldWeightKg ?? item?.quantity ?? 0).toFixed(3)} kg`
      : `${Number(item?.quantity || 0)}`;
    const label = item.isReturn ? `[RET] ${item.name || "Produit"}` : (item.name || "Produit");
    return `
      <div style="display:flex;justify-content:space-between;font-size:11px;line-height:1.5;">
        <span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:8px;">${escapeHtml(label)}</span>
        <span style="white-space:nowrap;">${qty}</span>
        <span style="white-space:nowrap;text-align:right;min-width:55px;">${escapeHtml(formatOrderAmount(item.lineTotal || 0))}</span>
      </div>`;
  }).join("");

  return `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="utf-8"/>
<title>Ticket ${escapeHtml(o.orderNumber || o.id || "")}</title>
<style>
  @page { size: 80mm auto; margin: 2mm; }
  * { margin:0; padding:0; box-sizing:border-box; }
  body {
    font-family: "Courier New", Courier, monospace;
    font-size: 11px;
    line-height: 1.4;
    color: #000;
    width: 76mm;
    padding: 2mm;
  }
  .center { text-align:center; }
  .bold { font-weight:700; }
  .line { border-top:1px dashed #000;margin:4px 0; }
  .double-line { border-top:2px solid #000;margin:4px 0; }
  .small { font-size:9px;color:#555; }
  .total-line {
    border-top:2px solid #000;
    margin-top:4px;
    padding-top:4px;
    font-size:13px;
    font-weight:700;
  }
</style>
</head>
<body>
  <div class="center bold" style="font-size:14px;">${escapeHtml(RECEIPT_STORE_INFO.name)}</div>
  ${o.isReturn ? '<div class="center bold" style="font-size:12px;">*** AVOIR ***</div>' : ""}
  <div class="center small">${escapeHtml(RECEIPT_STORE_INFO.address)}</div>
  <div class="center small">${escapeHtml(RECEIPT_STORE_INFO.phone)}${RECEIPT_STORE_INFO.email ? " · " + escapeHtml(RECEIPT_STORE_INFO.email) : ""}</div>

  <div class="line"></div>

  <div style="font-size:10px;">
    <div><span class="bold">Cmd:</span> ${escapeHtml(o.orderNumber || o.id || "")}</div>
    <div><span class="bold">Date:</span> ${escapeHtml(printedAt)}</div>
    <div><span class="bold">Paiement:</span> ${escapeHtml(o.paymentMethod || "Especes")}</div>
    ${o.refundedFrom ? `<div style="color:#dc2626;"><span class="bold">Cmd origine:</span> ${escapeHtml(o.refundedFrom)}</div>` : ""}
    ${o.note && o.note.includes("Carte cadeau") ? `
      <div style="font-size:10px;margin-top:4px;padding:3px;background:#f0f7f0;">
        ${o.note.split("|").filter((p) => p.includes("Carte cadeau")).map((p) => `<div>${escapeHtml(p.trim())}</div>`).join("")}
      </div>
    ` : ""}
    ${o.note && o.note.includes("Points fidelite") ? `
      <div style="font-size:10px;margin-top:4px;padding:3px;background:#f0f7f0;">
        ${o.note.split("|").filter((p) => p.includes("Points fidelite")).map((p) => `<div>${escapeHtml(p.trim())}</div>`).join("")}
      </div>
    ` : ""}
    ${o.client ? `<div><span class="bold">Client:</span> ${escapeHtml(o.client)}</div>` : ""}
    ${o.phone ? `<div><span class="bold">Tel:</span> ${escapeHtml(o.phone)}</div>` : ""}
  </div>

  <div class="line"></div>

  <div style="font-size:10px;">
    <div style="display:flex;justify-content:space-between;font-weight:700;margin-bottom:2px;">
      <span>Article</span>
      <span>Qt</span>
      <span style="text-align:right;min-width:55px;">Total</span>
    </div>
    ${items}
  </div>

  <div class="double-line"></div>

  <div style="font-size:11px;">
    <div style="display:flex;justify-content:space-between;"><span>Sous-total HT</span><span>${escapeHtml(formatOrderAmount(o.amount_ht || o.subtotal || 0))}</span></div>
    ${Object.entries(o?.tax_breakdown || {}).map(([rate, amount]) =>
      `<div style="display:flex;justify-content:space-between;"><span>TVA ${escapeHtml(rate)}</span><span>${escapeHtml(formatOrderAmount(amount))}</span></div>`
    ).join("")}
    ${Number(o.deliveryFee || 0) > 0 ? `<div style="display:flex;justify-content:space-between;"><span>Livraison</span><span>${escapeHtml(formatOrderAmount(o.deliveryFee))}</span></div>` : ""}
    <div class="total-line" style="display:flex;justify-content:space-between;">
      <span>TOTAL</span>
      <span>${escapeHtml(formatOrderAmount(o.amount || 0))}</span>
    </div>
  </div>

  ${o.note ? `<div class="line"></div><div class="small">${escapeHtml(o.note)}</div>` : ""}

  <div class="double-line"></div>

  <div class="center small">
    <div>${escapeHtml(RECEIPT_STORE_INFO.vat)}</div>
    <div>${escapeHtml(RECEIPT_STORE_INFO.siren)}</div>
    <div style="margin-top:4px;">Merci et a bientot !</div>
  </div>
</body>
</html>`;
};

export const printOrderCreditNote = (order) => {
  if (typeof window === "undefined" || !order) return false;
  return printHtml(buildAvoirPrintHtml(order), { title: `Avoir ${order.orderNumber || ""}`, width: 980, height: 900 });
};

export const printOrderInvoice = (order) => {
  if (typeof window === "undefined" || !order) return false;
  return printHtml(buildInvoicePrintHtml(order), { title: `Facture ${order.orderNumber || ""}`, width: 980, height: 900 });
};

export const printOrderDeliveryNote = (order) => {
  if (typeof window === "undefined" || !order) return false;
  return printHtml(buildDeliveryNotePrintHtml(order), { title: `Bon de livraison ${order.orderNumber || ""}`, width: 980, height: 900 });
};

export const printCashierReceipt = (order, options = {}) => {
  if (typeof window === "undefined" || !order) return false;
  const html = options.thermal
    ? buildThermalCashierReceiptHtml(order)
    : buildCashierReceiptPrintHtml(order);
  return printHtml(html, {
    title: `Ticket ${order.orderNumber || ""}`,
    width: options.thermal ? 320 : 420,
    height: options.thermal ? 700 : 820,
  });
};

export const isWeightedOrderItem = (item) =>
  item?.unitType === "kg" || item?.soldWeightKg !== null;

export const recalculateOrderTotals = (order) => {
  const items = (order.items || []).map((item) => {
    const normalizedItem = normalizeOrderItem(item);
    const effectiveQuantity = isWeightedOrderItem(normalizedItem)
      ? Number(
          normalizedItem.soldWeightKg ?? normalizedItem.quantity ?? 0
        )
      : Number(normalizedItem.quantity || 0);

    return {
      ...normalizedItem,
      lineTotal: Number(
        (Number(normalizedItem.unitPrice || 0) * effectiveQuantity).toFixed(2)
      ),
    };
  });

  const subtotal = Number(
    items.reduce((sum, item) => sum + Number(item.lineTotal || 0), 0).toFixed(2)
  );
  const deliveryFee = Number(order.deliveryFee || 0);

  return normalizeOrder({
    ...order,
    items,
    subtotal,
    amount: subtotal + deliveryFee,
  });
};

export const createCashierSaleOrder = async ({
  items = [],
  clientName = "",
  clientPhone = "",
  paymentMethod = "Especes",
  note = "",
  orderMode = "in_store",
  assignedDriverId = "",
  assignedDriverName = "",
}) => {
  const normalizedItems = (Array.isArray(items) ? items : [])
    .map(normalizeOrderItem)
    .filter((item) => item.productId && Number(item.lineTotal || 0) >= 0);

  if (!normalizedItems.length) {
    throw new Error("Aucun article a encaisser.");
  }

  const orderId = `cash-sale-${Date.now()}`;
  const orderNumber = `AL-${Date.now().toString().slice(-6)}`;
  const subtotal = Number(
    normalizedItems.reduce((sum, item) => sum + Number(item.lineTotal || 0), 0).toFixed(2)
  );

  for (const item of normalizedItems) {
    const saleQuantity =
      item.unitType === "kg" || item.soldWeightKg !== null
        ? Number(item.soldWeightKg ?? item.quantity ?? 0)
        : Number(item.quantity || 0);

    await fulfillInventorySale({
      productId: item.productId,
      quantity: saleQuantity,
      unitType: item.unitType || "piece",
      referenceId: orderId,
      reason: `Vente caisse ${orderNumber}`,
    });
  }

  const cashierOrder = normalizeOrder({
    id: orderId,
    orderNumber,
    client: clientName.trim() || "Client comptoir",
    phone: clientPhone.trim(),
    date: new Date().toISOString().slice(0, 10),
    items: normalizedItems,
    status: orderMode === 'in_store' ? "Livree" : "En attente",
    paymentStatus: "Payee",
    dispatchStatus: orderMode === 'in_store' ? "Livree" : "Non preparee",
    deliveryType: orderMode === 'delivery' ? "Livraison" : (orderMode === 'takeaway' ? "A emporter" : "Caisse magasin"),
    orderMode,
    savMessages: [],
    subtotal,
    deliveryFee: 0,
    amount: subtotal,
    paymentMethod,
    note: note ? `Vente caisse - ${note}` : "Vente caisse",
    assignedDriverId,
    assignedDriverName,
  });

  const cachedOrders = await loadOrders();

  if (!isSupabaseConfigured || !supabase) {
    await saveOrders([cashierOrder, ...cachedOrders]);
    return cashierOrder;
  }

  try {
    const { error: orderInsertError } = await supabase.from("orders").insert({
      id: cashierOrder.id,
      order_number: cashierOrder.orderNumber,
      customer_name: cashierOrder.client,
      customer_phone: cashierOrder.phone,
      customer_email: cashierOrder.email || "",
      customer_id: null,
      cashier_id: null,
      cart_id: null,
      address_id: null,
      billing_address_id: null,
      shipping_address_id: null,
      delivery_zone_id: null,
      delivery_slot_id: null,
      status: "delivered",
      payment_status: "paid",
      subtotal: cashierOrder.subtotal,
      discount_total: 0,
      delivery_fee: 0,
      total_amount: cashierOrder.amount,
      currency: "EUR",
      delivery_label: cashierOrder.deliveryType,
      order_mode: cashierOrder.orderMode,
      sav_messages: cashierOrder.savMessages,
      dispatch_status: "delivered",
      note: cashierOrder.note,
      assigned_driver_id: cashierOrder.assignedDriverId || null,
      assigned_driver_name: cashierOrder.assignedDriverName || "",
    });

    if (orderInsertError) {
      throw orderInsertError;
    }

    for (const item of normalizedItems) {
      await supabase.from("order_items").insert({
        order_id: cashierOrder.id,
        product_id: item.productId,
        variant_id: item.variantId,
        product_name: item.name,
        variant_name: item.variantName || "",
        quantity: item.quantity,
        unit_type: item.unitType || "piece",
        sold_weight_kg:
          item.unitType === "kg" || item.soldWeightKg !== null
            ? Number(item.soldWeightKg ?? item.quantity ?? 0)
            : null,
        unit_price: item.unitPrice,
        line_total: item.lineTotal,
      });
    }

    await supabase.from("payments").insert({
      order_id: cashierOrder.id,
      provider: "manual",
      provider_payment_id: "",
      amount: cashierOrder.amount,
      status: "succeeded",
      payment_method: cashierOrder.paymentMethod || "Especes",
      paid_at: new Date().toISOString(),
    });
  } catch (error) {
    await saveOrders([cashierOrder, ...cachedOrders]);
    return cashierOrder;
  }

  await saveOrders([cashierOrder, ...cachedOrders]);
  return cashierOrder;
};


export async function applyPartialReturn(originalOrderNumber, returnedItems) {
  const orders = await loadOrders();
  const orderIndex = orders.findIndex(o => o.orderNumber === originalOrderNumber || o.id === originalOrderNumber);
  
  if (orderIndex === -1) {
    console.error("Order " + originalOrderNumber + " not found for partial return.");
    return null;
  }
  
  const order = orders[orderIndex];
  let refundAmount = 0;
  
  returnedItems.forEach(retItem => {
    const prodId = retItem.product?.id || retItem.productId;
    const origItem = order.items.find(i => (i.productId === prodId || i.id === prodId) && i.unitPrice === Math.abs(retItem.price));
    if (origItem) {
      const returnedQty = Math.abs(retItem.quantity);
      origItem.returnedQty = (origItem.returnedQty || 0) + returnedQty;
      origItem.returnReason = retItem.returnReason;
      
      const refundLine = Math.abs(retItem.lineTotal);
      origItem.returnedTotal = (origItem.returnedTotal || 0) + refundLine;
      refundAmount += refundLine;
    }
  });
  
  if (refundAmount > 0) {
    if (order.originalAmount === undefined) {
      order.originalAmount = order.amount;
    }
    
    order.amount = order.amount - refundAmount;
    if (order.subtotal !== undefined) {
      order.subtotal = order.subtotal - refundAmount;
    }
    
    order.hasReturns = true;
    order.refundMode = "refund";
    order.refundAmount = (order.refundAmount || 0) + refundAmount;
    
    if (!order.creditNoteNumber) {
      order.creditNoteNumber = buildCreditNoteNumber(order);
      order.creditNoteIssuedAt = new Date().toISOString();
    }
    
    orders[orderIndex] = order;
    await saveOrders(orders);
  }
  
  return order;
}

export const buildBonDeCommandePrintHtml = (order) => {
  const itemsHtml = (order.items || []).map((item) => {
    return `<tr>
      <td style="padding: 10px; border-bottom: 1px solid #eee;">${escapeHtml(item.name)} ${item.variantName ? '<small>(' + escapeHtml(item.variantName) + ')</small>' : ''}</td>
      <td style="padding: 10px; border-bottom: 1px solid #eee; text-align: center;">${item.quantity} ${item.unitType !== 'piece' ? escapeHtml(item.unitType) : ''}</td>
    </tr>`;
  }).join("");

  return `
    <div style="font-family: sans-serif; max-width: 800px; margin: 0 auto; padding: 20px;">
      <div style="text-align: center; margin-bottom: 30px;">
        <h2 style="margin:0;">BON DE COMMANDE</h2>
        <p style="margin:5px 0;">Commande N°: ${escapeHtml(order.orderNumber || order.id)}</p>
        <p style="margin:5px 0;">Mode: ${escapeHtml(getOrderModeLabel(order.orderMode))}</p>
      </div>
      <div style="display: flex; justify-content: space-between; margin-bottom: 30px;">
        <div>
          <strong>Client:</strong> ${escapeHtml(order.client)}<br>
          <strong>Tel:</strong> ${escapeHtml(order.phone)}
        </div>
        <div style="text-align: right;">
          <strong>Date:</strong> ${formatOrderDate(order.date)}<br>
          <strong>Statut:</strong> ${escapeHtml(order.status)}
        </div>
      </div>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
        <thead>
          <tr style="background-color: #f8f9fa;">
            <th style="padding: 10px; border-bottom: 2px solid #ddd; text-align: left;">Produit</th>
            <th style="padding: 10px; border-bottom: 2px solid #ddd; text-align: center;">Quantité</th>
          </tr>
        </thead>
        <tbody>${itemsHtml}</tbody>
      </table>
      ${order.note ? `<div style="margin-top:20px; padding:15px; background:#f9f9f9; border-left:4px solid #6c757d;"><strong>Notes / Préparation:</strong><br>${escapeHtml(order.note).replace(/\n/g, '<br>')}</div>` : ''}
    </div>
  `;
};

export const printBonDeCommande = (order) => {
  printHtml(buildBonDeCommandePrintHtml(order));
};
